import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CustomerInfosService } from '../customer-infos/customer-infos.service';
import { DefaultResolver } from './default.resolver';
import { LocalStorageService} from '../shared/local-storage.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CustomerInfosOrderResolver extends DefaultResolver implements Resolve<any> {

  constructor(
    private customerInfosService: CustomerInfosService,
    private localStorageService: LocalStorageService,
    ) {
     super();
  }

  resolve(route: ActivatedRouteSnapshot) {
    let step = this.getRouteParam(route, 'step');
    let data = null;
    switch (+step) {
      case 1 :
        data = Observable.forkJoin(
            this.customerInfosService.getAgreements()
            .map((response) => {
              return response.json();
            }),
            this.customerInfosService.getProductionKinds()
            .map((response) => {
              return response.json();
            }),
            this.customerInfosService.getMappingBetweenProductionKindAndAgreement()
            .map((response) => {
              return response.json();
            })
        );
        break;
      case 2 :
        const thirdParty = this.localStorageService.get('mylab_customer_infos', 'selectedProducerBackup', 'ThirdParty');
        const producerId = thirdParty.id;
        const producerSiret = thirdParty.siret;
        data = Observable.forkJoin(
            this.customerInfosService.getAgreementByProducerId(producerId),
            this.customerInfosService.getLastTurnByProducerSiret(producerSiret),
            this.customerInfosService.getDefaultRelations(producerSiret),
        );
        break;
    }
    return data;
  }

}



// WEBPACK FOOTER //
// ./src/app/resolvers/customer-infos-order.resolver.ts